import React from 'react';
import { connect } from 'react-redux';
import { Page } from 'signoxe/components';
import { getAsset } from 'signoxe/selectors';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import {
  addUrlAsset, fetchUrlAssets, setPageTitle, updateUrlAsset,
} from '../../actions';
import './styles.scss';


class URLAssetEditPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {...props.asset};
  }

  componentDidMount() {
    this.props.fetchUrlAssets();
    if (this.props.asset) {
      this.props.setPageTitle(`${this.props.asset.id ? 'Editing' : 'Adding'} URL Asset`);
    } else {
      this.props.setPageTitle('Adding URL Asset');
    }
  }

  handleCancel = () => this.props.history.push('/assets');

  handleNameChange = (e) => this.setState({name: e.currentTarget.value});

  handleUrlChange = (e) => this.setState({asset_url: e.currentTarget.value});

  handleSave = () => {
    if (this.props.asset) {
      this.props.updateUrlAsset(this.props.asset.id, this.state);
      this.props.history.push(`/asset/${this.props.asset.id}`);
    } else if (this.isNewAsset()) {
      this.props.addUrlAsset(this.state);
      this.props.history.push('/assets');
    }
  };

  isNewAsset = () => this.props.match.params.id === undefined;

  saveEnabled() {
    return this.state && this.state.name && this.state.asset_url;
  }

  render() {
    if (this.props.asset === undefined && this.props.match.params.id) {
      return <div>Invalid asset.</div>;
    }

    const {name, asset_url} = this.state;

    return <Page className="asset-editing-page">
      <input type="text" placeholder="Asset name"
             value={name || ''}
             onChange={this.handleNameChange}/>
      <input type="url" placeholder="Content URL"
             value={asset_url}
             onChange={this.handleUrlChange}/>

      <Box direction="row" justifyContent="flex-end" className="actions button-group">
        <Button primary onClick={this.saveEnabled() ? this.handleSave : null}>Save</Button>
        <Button secondary onClick={this.handleCancel}>Cancel</Button>
      </Box>
    </Page>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    asset: getAsset(state, parseInt(ownProps.match.params.id, 10)),
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPageTitle: title => dispatch(setPageTitle(title)),
    addUrlAsset: data => dispatch(addUrlAsset(data)),
    fetchUrlAssets: () => dispatch(fetchUrlAssets()),
    updateUrlAsset: (id, data) => dispatch(updateUrlAsset(id, data)),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(URLAssetEditPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/URLAssetEditPage/index.js